import { createApp, h } from 'vue'
import { createInertiaApp, router } from '@inertiajs/vue3'
import 'ant-design-vue/dist/reset.css'
import '@fontsource-variable/inter'
import '@fontsource-variable/manrope'
import { configureAntDesign } from '../ant_design'
import '../styles/application.css'
import '../styles/public.css'

const pages = import.meta.glob('../pages/**/*.vue')

const refreshCsrfToken = (token) => {
  const meta = document.querySelector('meta[name="csrf-token"]')
  if (meta && token) meta.setAttribute('content', token)
}

router.on('success', (event) => refreshCsrfToken(event.detail.page?.props?.csrfToken))

createInertiaApp({
  title: (title) => (title ? `${title} · UXIOM` : 'UXIOM — Digital product studio'),
  resolve: (name) => {
    const page = pages[`../pages/${name}.vue`]
    if (!page) throw new Error(`Page not found: ${name}`)
    return page().then((module) => module.default)
  },
  setup({ el, App, props, plugin }) {
    refreshCsrfToken(props?.initialPage?.props?.csrfToken)
    const app = createApp({ render: () => h(App, props) }).use(plugin)
    configureAntDesign(app)
    app.mount(el)
  },
})
